export enum TooltipFilterMethodEnum {
  Daily = 'Daily',
}
